import React, { FC } from 'react'

const DisplayUsers: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="389"
    height="165"
    viewBox="0 0 389 165"
    fill="none"
  >
    <path
      stroke="#262A44"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="3"
      d="M65.24 115.962H35.39c-3.88 0-7.023-2.803-7.023-6.264V78.379c0-3.46 3.143-6.263 7.024-6.263h66.722c3.88 0 7.023 2.803 7.023 6.263v31.319c0 3.461-3.143 6.264-7.023 6.264h-1.756M39.906 88.27h25.385M39.906 97.5h13.846"
    />
    <path
      stroke="#EC1C24"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="3"
      d="m91.484 124.167-4.117-8.309 7.925-4L73.76 97.5l-1.545 26.013 7.924-4.005 3.952 7.992 7.393-3.333Z"
    />
    <path
      stroke="#262A44"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="3"
      d="M71.008 46.73H46.832M78.254 46.73h3.626M82.543 37.5H58.367M126.633 37.5H97.695c-3.88 0-7.023 2.803-7.023 6.264v19.12m34.617 18.462h-6.925M99.902 53.654H123.5M99.902 62.885h15"
    />
    <path
      fill="#EC1C24"
      d="M144.12 81.54c1.813-1.44 2.64-2.107 2.48-2 5.227-4.32 9.333-7.867 12.32-10.64 3.04-2.773 5.6-5.68 7.68-8.72 2.08-3.04 3.12-6 3.12-8.88 0-2.187-.507-3.893-1.52-5.12-1.013-1.227-2.533-1.84-4.56-1.84-2.027 0-3.627.773-4.8 2.32-1.12 1.493-1.68 3.627-1.68 6.4h-13.2c.107-4.533 1.067-8.32 2.88-11.36 1.867-3.04 4.293-5.28 7.28-6.72 3.04-1.44 6.4-2.16 10.08-2.16 6.347 0 11.12 1.627 14.32 4.88 3.253 3.253 4.88 7.493 4.88 12.72 0 5.707-1.947 11.013-5.84 15.92-3.893 4.853-8.853 9.6-14.88 14.24h21.6V91.7h-40.16V81.54Zm46.663-30.96c.213-5.707 2.08-10.107 5.6-13.2 3.52-3.093 8.293-4.64 14.32-4.64 4 0 7.413.693 10.24 2.08 2.88 1.387 5.04 3.28 6.48 5.68 1.493 2.4 2.24 5.093 2.24 8.08 0 3.52-.88 6.4-2.64 8.64-1.76 2.187-3.813 3.68-6.16 4.48v.32c3.04 1.013 5.44 2.693 7.2 5.04 1.76 2.347 2.64 5.36 2.64 9.04 0 3.307-.773 6.24-2.32 8.8-1.493 2.507-3.707 4.48-6.64 5.92-2.88 1.44-6.32 2.16-10.32 2.16-6.4 0-11.52-1.573-15.36-4.72-3.787-3.147-5.787-7.893-6-14.24h13.28c.053 2.347.72 4.213 2 5.6 1.28 1.333 3.147 2 5.6 2 2.08 0 3.68-.587 4.8-1.76 1.173-1.227 1.76-2.827 1.76-4.8 0-2.56-.827-4.4-2.48-5.52-1.6-1.173-4.187-1.76-7.76-1.76h-2.56V56.66h2.56c2.72 0 4.907-.453 6.56-1.36 1.707-.96 2.56-2.64 2.56-5.04 0-1.92-.533-3.413-1.6-4.48-1.067-1.067-2.533-1.6-4.4-1.6-2.027 0-3.547.613-4.56 1.84-.96 1.227-1.52 2.747-1.68 4.56h-13.36Zm67.578 25c2.08 0 3.73.63 4.95 1.89 1.24 1.26 1.86 3.01 1.86 5.25v9.78h-5.1v-9.09c0-1.08-.29-1.91-.87-2.49-.56-.6-1.34-.9-2.34-.9-1 0-1.79.3-2.37.9-.56.58-.84 1.41-.84 2.49v9.09h-5.1v-9.09c0-1.08-.29-1.91-.87-2.49-.56-.6-1.34-.9-2.34-.9-1 0-1.79.3-2.37.9-.56.58-.84 1.41-.84 2.49v9.09h-5.13V75.76h5.13v2.1c.52-.7 1.2-1.25 2.04-1.65.84-.42 1.79-.63 2.85-.63 1.26 0 2.38.27 3.36.81 1 .54 1.78 1.31 2.34 2.31.58-.92 1.37-1.67 2.37-2.25 1-.58 2.09-.87 3.27-.87Zm15.527-5.28v22.2h-5.13V70.3h5.13Zm13.918 5.28c1.96 0 3.52.64 4.68 1.92 1.18 1.26 1.77 3 1.77 5.22v9.78h-5.1v-9.09c0-1.12-.29-1.99-.87-2.61-.58-.62-1.36-.93-2.34-.93-.98 0-1.76.31-2.34.93-.58.62-.87 1.49-.87 2.61v9.09h-5.13V75.76h5.13v2.22c.52-.74 1.22-1.32 2.1-1.74.88-.44 1.87-.66 2.97-.66Z"
    />
  </svg>
)

export default DisplayUsers
